<template>
  <div v-if="showBar" class="progress-bar-wrapper">
    <div class="progress-bar" :style="{ width: percent + '%' }"></div>
    <span class="progress-label-below">{{ percent }}%</span>
  </div>
</template>

<script setup>
import { computed, watch, ref } from 'vue'
const props = defineProps({
  percent: { type: Number, required: true },
  visible: { type: Boolean, default: true }
})

const showBar = ref(props.visible)

let hideTimeout = null
watch(
  () => [props.percent, props.visible],
  ([newPercent, newVisible]) => {
    if (newVisible === false) {
      showBar.value = false
      return
    }
    if (newPercent < 100) {
      showBar.value = true
      if (hideTimeout) clearTimeout(hideTimeout)
    } else if (newPercent >= 100) {
      if (hideTimeout) clearTimeout(hideTimeout)
      // 400ms Verzögerung, damit die Animation sichtbar bleibt
      hideTimeout = setTimeout(() => {
        showBar.value = false
      }, 4000)
    }
  },
  { immediate: true }
)
</script>

. 
<style scoped lang="scss">
@use "@/scss/settings/variables.scss" as variables;
.progress-bar-wrapper {
  width: 100%;
  height: 6px;
  background: #e5e7eb;
  position: relative;
  z-index: 200;
  top: 75px;
}
.progress-bar {
  height: 100%;
  background: variables.$sellwerk-color-main-gradient;
  transition: width 0.3s cubic-bezier(.4,0,.2,1);
  border-radius: 2px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.progress-bar::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 200%;
  height: 100%;
  background: repeating-linear-gradient(
    120deg,
    rgba(255,255,255,0.18) 0px,
    rgba(255,255,255,0.18) 20px,
    transparent 20px,
    transparent 40px
  );
  animation: progress-bar-stripes 1.2s linear infinite;
  pointer-events: none;
}
.progress-label-below {
  display: block;
  margin-top: 2px;
  margin-left: 2px;
  color: #222;
  font-size: variables.$font-2xs;
  font-weight: 400;
  letter-spacing: 0.2px;
  user-select: none;
  pointer-events: none;
  text-align: left;
}
@keyframes progress-bar-stripes {
  0% { transform: translateX(0); }
  100% { transform: translateX(-40px); }
}
</style>
